import BaseResource from './index'
import BoardResource from './board'
import UserResource from './user'

export default class TeamResource extends BaseResource {
    static endpoint = '/teams'

    static related() {
        return {
            members: UserResource,
            board: BoardResource,
        }
    }

    // Self-service Open Team Registration - separate from the standard POST /teams create,
    // which stays staff-only (model permission gated) for the admin's manual team creation.
    static async register(board, name) {
        const result = await this.wrap('/register').post({ board, name })
        return new this(result.data)
    }

    // Asks to join; returns the request (PENDING until the owner accepts, ACCEPTED when the team took the racer straight away).
    async join() {
        const result = await this.wrap('/join').post()
        return result.data
    }

    async draft(userId) {
        const result = await this.wrap('/draft').post({ user: userId })
        return result.data
    }

    async invite(emails) {
        const result = await this.wrap('/invite').post({ emails })
        return result.data
    }

    toString() {
        return this.attributes.name
    }
}
